import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  goTo(link){
      window.location.replace(link);
  };

  ngOnInit() {
      window.onscroll = function() {
          growShrinkLogo()
      };

      function growShrinkLogo() {
          let logo = document.getElementById('logo'),
              header = document.getElementById('header');

          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
              header.classList.add('toggled');

              if(document.getElementById('page-info')){
                  document.getElementById('page-info').classList.add('toggled');
              }
          } else {
              header.classList.remove('toggled');
              if(document.getElementById('page-info')){
                  document.getElementById('page-info').classList.remove('toggled');
              }
          }
      }
  }

}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/components/view/navbar/navbar.component.ts